import { createAction } from '@reduxjs/toolkit'

export const firebaseInitializedAction = createAction<boolean>('auth/firebase-initialized')
export const registerSignOutAction = createAction<void>('auth/sign-out')
